<span class="login-block">
<a (mousedown)="profile()" *ngIf="loggedIn" class="login"></a>
<button (mousedown)="GoogleAuth()" *ngIf="!loggedIn" class="text-main link-btn">LOGIN</button>
</span>
